import { createSelector } from 'reselect';
import { get } from 'lodash';

export const uiSelector = state => state.ui;

export const createChatSelector = state => state.ui.createChat;
export const contextbarSelector = state => state.ui.contextbar;
export const uiDrawerSelector = state => state.ui.drawer;
export const uiSidebarSelector = state => state.ui.sidebar;
export const uiOverlaySelector = state => state.ui.overlay;
export const uiPopupSelector = state => state.ui.popup;
export const selectTheme = state => state.ui.theme;
export const selectDefaultTab = state => state.ui.defaultTab;
export const selectVideoCallEndPopup = state => state.ui.videoCallEndPopup;

export const selectUiPopupVisible = createSelector(
  uiPopupSelector,
  popup => get(popup, 'visible', false),
);
export const selectUiPopupContentOptions = createSelector(
  uiPopupSelector,
  popup => get(popup, 'contentOptions', {}),
);
export const selectUiPopupContentType = createSelector(
  uiPopupSelector,
  popup => get(popup, 'contentType'),
);

export const uiFormInProgressSelector = state => state.ui.formInProgress;

export const uiImageViewerSelector = state => state.ui.imageViewer;
export const uiPdfViewerSelector = state => state.ui.pdfViewer;

export const uiLocaleSelector = state => state.ui.locale;
export const uiOnlineSelector = state => state.ui.online;

export const drawerVisibleSelector = createSelector(
  uiDrawerSelector,
  drawer => get(drawer, 'visible', false),
);

export const overlayVisibleSelector = createSelector(
  uiOverlaySelector,
  overlay => get(overlay, 'visible', false),
);

export const contextbarVisibilitySelector = createSelector(
  contextbarSelector,
  contextbar => get(contextbar, 'visible', false),
);

export const popupSecondaryContentVisibilitySelector = createSelector(
  uiPopupSelector,
  popup => get(popup, 'secondaryContentVisible', false),
);

export const createChatVisibilitySelector = createSelector(
  createChatSelector,
  createChat => get(createChat, 'visible', false),
);

export const selectDefaultTabId = createSelector(
  selectDefaultTab,
  state => get(state, 'id', null),
);



// WEBPACK FOOTER //
// ./src/redux/ui/selectors.js